import * as React from "react";
import * as main from "../../main.module.scss";
import * as res from "./style.module.scss";
export const ResultsStudents = () => {
  return (
    <section className={`${res.res} ${main.hugs}`}>
      <div className="container">
        <h2>Результаты учеников Advance</h2>
        <p className={res.subtitle}>Это делают обычные дети без сверхспособностей после обучения</p>
        <ul className={res.numsList}>
          <li>
            <h3><span>100</span><span>слов</span></h3>
            <p>Запоминают ученики Advance за один час</p>
          </li>
          <li>
            <h3><span>5</span><span>дней</span></h3>
            <p>Необходимо для полного изучения одного учебника </p>
          </li>
          <li>
            <h3><span>2</span><span>месяца</span></h3>
            <p>Требуется для прохождения годовой школьной программы </p>
          </li>
        </ul>
      </div>

      <div className={res.lineWrap}>
        <ul className={`${res.line} ${res.marquee}`}>
          <li>Запоминают 100 слов за час</li>
          <li>Проходят годовую программу за 2 месяца</li>
          <li>Знают 1 000 знаков после числа Пи</li>
          <li>Запоминают все элементы таблицы Менделеева за 1 час</li>
          <li>Запоминают любую формулу за 5 минут</li>
          <li>Проходят учебник за 1 неделю</li>
        </ul>
        <ul aria-hidden="true" className={`${res.line} ${res.marquee}`}>
          <li>Запоминают 100 слов за час</li>
          <li>Проходят годовую программу за 2 месяца</li>
          <li>Знают 1 000 знаков после числа Пи</li>
          <li>Запоминают все элементы таблицы Менделеева за 1 час</li>
          <li>Запоминают любую формулу за 5 минут</li>
          <li>Проходят учебник за 1 неделю</li>
        </ul>
      </div>
    </section>
  );
};
